import { Link } from "react-router-dom";
import "./LocationCard.css";
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import ReactCountryFlag from "react-country-flag";

const countryMap = new Map([
  ['Estonia', 'EE'],
  ['Bulgaria', 'BG'],
  ['United Kingdom', 'UK'],
  ['Spain', 'ES']
])

const LocationCard = ({ id, cityName, country, locationName, location, designsCount, isAdmin, image }) => {
  const state = { id, cityName, location, locationName, designsCount, image, country };


  const { t } = useTranslation();

  const designsTitle = `${designsCount} Designs`;
  const url = isAdmin ? `/admin/${cityName}/${id}` : `/${cityName}/${id}`;

  return (
    <div className="location_card_container">
        <Link to={url} state={state} style={{textDecoration: 'none'}}>
          <div className="location_image_wrapper">
            <img className="location_image" src={image} />
            <div style={leftChipStyles}>
              <Chip 
              sx={{
                "& .MuiChip-label": {
                  padding: '4px 12px'
                }
              }} 
              label={designsTitle} 
              style={
                {backgroundColor: '#06C067', color: '#fff', fontFamily: 'Manrope', fontWeight: '700', fontSize: '13px', height: '25px', fontWeight: '500'}
              }/>
            </div>
          </div>
          <div className="label_location_wrapper">
            <div className="label_data_wrapper" >
                <p className="label_location_name">{locationName}</p>
                <p className="label_city_name">
                  <ReactCountryFlag
                  countryCode={countryMap.get(country)}
                  svg
                  style={{ width: '32px', height: '20px', marginLeft: '-2px' }}
                  title={country}
                  />{cityName}
                </p>
            </div>
            <div className="location_btn_wrapper">
              <button 
                className="location_btn"
              >See Designs</button>
            </div>
            </div>
        </Link>      
    </div>
  );
};

export default LocationCard;

const leftChipStyles = {
  position: "absolute", 
  top: 18, 
  left: 18, 
  zIndex: 50, 
  maxWidth: '110px', 
  height: 20,
};

